import React from "react";
import Button from "../button/button.component";

const OurOffering = () => {
  const handleSeeMoreProductService = () => {
    window.location.href = "/service/product";
  };  
  
  const handleSeeMoreStaffService = () => {
    window.location.href = "/service/staff";
  };

  return (
    <div
      className="flex flex-col w-full border-y-8 px-2 pt-8 lg:px-11 pb-11 lg:pt-24
    border-[#a0a5e2] bg-white/0 backdrop-blur"
    >
      <div className="flex flex-col w-full gap-6 md:gap-10">
        <h1
          className="text-2xl lg:text-4xl font-bold"
          data-aos="fade-up"
          data-aos-duration={1000}
          data-aos-delay={400}
        >
          Our Offerings
        </h1>
        <div className="flex flex-col lg:flex-row w-full gap-3 lg:gap-6">
          <div
            className="flex w-full lg:w-1/2 h-80 lg:h-[33rem] border
       border-greyBg bg-white/0 backdrop-blur"
          >
            <div
              className="w-full flex h-full relative group cursor-pointer"
              data-aos="zoom-out-up"
              data-aos-duration={1000}
              data-aos-delay={400}
            >
              <div className="h-full w-full group-hover:bg-transparent">
                <img
                  src="https://cdn.pixabay.com/photo/2022/05/12/03/19/binary-code-7190628_1280.jpg"
                  className="h-full w-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-sm"
                  alt="our-offering"
                />
              </div>
              <div className="h-full w-full absolute top-0 left-0 bg-opacity-60">
                <div className="flex justify-center items-center flex-col gap-3 lg:gap-5 h-full w-full px-3 lg:px-5 opacity-100">
                  <h1
                    className="text-xl lg:text-2xl font-bold"
                    data-aos="fade-down"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    Product Engineering Services
                  </h1>
                  <p
                    className="text-base font-semibold"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    What sells is not an idea but a well executed product.
                    Product development is more complex than developing an end
                    to end product.
                  </p>
                  <Button onClick={() => handleSeeMoreProductService()}>
                    See More
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex w-full lg:w-1/2 h-80 lg:h-[33rem] border
       border-greyBg bg-white/0 backdrop-blur"
          >
            <div
              className="w-full flex h-full relative group cursor-pointer"
              data-aos="zoom-out-up"
              data-aos-duration={1000}
              data-aos-delay={400}
            >
              <div className="h-full w-full bg-transparent">
                <img
                  src="https://i.ibb.co/DrndcrR/pexels-ketut-subiyanto-4350084.jpg"
                  className="h-full w-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur"
                  alt="our-offering"
                />
              </div>
              <div className="h-full w-full absolute top-0 left-0 bg-opacity-60">
                <div className="flex justify-center items-center flex-col gap-3 lg:gap-5 h-full w-full px-3 lg:px-5 opacity-100">
                  <h1
                    className="text-xl lg:text-2xl font-bold"
                    data-aos="fade-down"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    Staff Augmentation
                  </h1>
                  <p
                    className="text-base font-semibold"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                    data-aos-delay={500}
                  >
                    Staff Augmentation is an outsourcing service where an
                    organization provides their employee on a contract basis to
                    add on to the capacity of your company
                  </p>
                  <Button onClick={handleSeeMoreStaffService}>See More</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurOffering;
